/**
 * Formats a crypto price value with appropriate decimal places based on the price range
 * @param price - The price value to format
 * @returns Formatted price string
 */
export function formatPrice(price: number | string): string {
    if (typeof price === "string") {
        price = Number.parseFloat(price);
    }

    if (Number.isNaN(price) || price === 0) {
        return "0";
    }

    // For prices >= $1, show up to 2 decimal places
    if (price >= 1) {
        return Number(price.toFixed(2)).toLocaleString();
    }

    // For prices < $1, show appropriate significant digits without scientific notation
    if (price < 0.000001) {
        return price.toFixed(9);
    } else if (price < 0.000001) {
        return price.toFixed(8);
    } else if (price < 0.00001) {
        // Show 7 significant digits for very small prices
        return price.toFixed(7);
    } else if (price < 0.0001) {
        return price.toFixed(6);
    } else if (price < 0.001) {
        return price.toFixed(5);
    } else if (price < 0.01) {
        return price.toFixed(4);
    } else if (price < 1) {
        return price.toFixed(3);
    }

    // Fallback case (shouldn't be reached due to above conditions)
    return price.toString();
}
